"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPermissionGroupMembership_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var UserPermissionGroupMembership_Factory = /** @class */ (function () {
    function UserPermissionGroupMembership_Factory() {
    }
    UserPermissionGroupMembership_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            PermissionGroupId: model.PermissionGroupId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            UserId: model.UserId,
        };
        return result;
    };
    UserPermissionGroupMembership_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            PermissionGroupId: model.PermissionGroupId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            UserId: model.UserId,
        };
        return result;
    };
    return UserPermissionGroupMembership_Factory;
}());
exports.UserPermissionGroupMembership_Factory = UserPermissionGroupMembership_Factory;
